import { render, staticRenderFns } from "./FloatAvatar.vue?vue&type=template&id=4351b87f&scoped=true"
import script from "./FloatAvatar.vue?vue&type=script&lang=ts"
export * from "./FloatAvatar.vue?vue&type=script&lang=ts"
import style0 from "./FloatAvatar.vue?vue&type=style&index=0&id=4351b87f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4351b87f",
  null
  
)

export default component.exports